/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".non-links[_ngcontent-%COMP%]{display:inline-block;line-height:60px}.noborder[_ngcontent-%COMP%]{border:none!important}ul.account-dropdown[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:list-item}[_nghost-%COMP%]{display:flex;align-items:center}"];
export { styles as styles };
